import { render, staticRenderFns } from "./RejectedApplications.vue?vue&type=template&id=61e0a5a7"
import script from "./RejectedApplications.vue?vue&type=script&lang=js"
export * from "./RejectedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports